import { Post } from "@/utils";
import { ApiPath } from "@/enums";

export default {
  namespaced: true,
  state: {
    current_registration: {
      IsComplete: false
    }
  },
  mutations: {
    SET_REGISTRATION(state, payload) {
      state.current_registration = payload;
    }
  },
  actions: {
    store({ commit }, registration) {
      return axios
        .post(
          process.env.VUE_APP_API_BASE_URI + "identity/register",
          registration
        )
        .then(res => {
          commit("SET_REGISTRATION", registration);

          return registration;
        })
        .catch(res => {
          const errors = res.response.data;

          throw errors;
        });
    },
    getRoles({ commit }) {
      return axios
        .get(`${process.env.VUE_APP_API_BASE_URI}identity/roles`)
        .then(res => res.data);
    },
    async register({}, body) {
      const { data: registration } = await Post(
        `${ApiPath.Organisation}/register`,
        body
      );
      return registration;
    }
  }
};
